import { FC } from 'react';
import { NGIcon } from 'src/styles/theme/components/NGIcon/NGIcon';
import { EIcon } from 'src/styles/theme/components/NGIcon/NGIcon.enum';
import { ESize, ETextColor } from 'src/styles/theme/utils/enums';
import { StyledNGIconButton } from './NGIconButton.styles';
import { INGIconButton } from './NGIconButton.type';

const NGIconButton: FC<INGIconButton> = ({
	onClick,
	disabled = false,
	isHidden = false,
	isActive = true,
	size = ESize.m,
	color = ETextColor.white,
	secondary = false,
	fullWidth = false,
	startIcon,
	shadowColor,
	gradientColor,
	customOpacity,
	...otherProps
}) => {
	return (
		<StyledNGIconButton
			onClick={onClick ? onClick : undefined}
			disabled={disabled}
			isHidden={isHidden}
			isActive={isActive}
			fullWidth={fullWidth}
			size={size}
			gradientColor={gradientColor}
			customOpacity={customOpacity}
			{...otherProps}
		>
			<NGIcon type={startIcon || EIcon.none} size={size} color={color} shadowColor={shadowColor} />
		</StyledNGIconButton>
	);
};

export { NGIconButton };
